import React, { FC } from 'react';
import { MiscellaneousInformation } from '../../../../../enums/MiscellaneousInformation';
import BlueIcon from '../../../../../assets/icons/inline/arrow-up-right-blue-big.inline.svg';
import BlackIcon from '../../../../../assets/icons/inline/arrow-up-right-black.inline.svg';
import * as classes from './MiscellaneousInformationTitle.module.scss';
import cn from 'classnames';

interface Props {
  label: string;
  type: MiscellaneousInformation;
}

const MiscellaneousInformationTitle: FC<Props> = ({ label, type }) => {
  return (
    <div
      className={cn(
        classes.wrapper,
        type === MiscellaneousInformation.PROF_ASSOCIATIONS && classes.profAssociations,
        type === MiscellaneousInformation.AWARDS && classes.awards,
      )}
    >
      <div className={classes.iconWrapper}>{MiscellaneousInformation.AWARDS === type ? <BlueIcon /> : <BlackIcon />}</div>
      <div className={classes.label}>{label}</div>
    </div>
  );
};

export default MiscellaneousInformationTitle;
